import { render, staticRenderFns } from "./JobTypeEditor.vue?vue&type=template&id=6f63d1f0&"
import script from "./JobTypeEditor.vue?vue&type=script&lang=ts&"
export * from "./JobTypeEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports